export const white = '#FFF'
export const black = '#000'

export const green = {
  500: '#FE28D6',
}

export const red = {
  100: '#FE28D6',
  200: '#FE28D6',
  500: '#FE28D6',
  600: '#FE28D6',
}

export const purple = {
  100: '#FE28D6',
  200: '#FE28D6',
  300: '#FE28D6',
  400: '#FE28D6',
  500: '#FE28D6',
  600: '#9C28EC',
  800: '#FE28D6',
}
